/* Register the Identium FX service worker for PWA functionality. */
const SW_PATH = '/IdentiumFx/service-worker.js';

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(SW_PATH, { scope: '/IdentiumFx/' })
      .then(reg => {
        // Detect updates and reload silently
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              // New SW ready — activate it next visit
              reg.waiting?.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch(err => console.warn('SW registration failed:', err));
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready.then(reg => reg.unregister()).catch(() => {});
}
